import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TestSetupModule } from '@nrwl/test-setup';
import { CommonLibModule } from '@nrwl/common-lib';
import {
  CCM_PERIOD_TYPES,
  DMM_PERIOD_TYPES,
  MD_NAME_FORMAT_TYPES,
  MEG_ID_FORMAT_TYPES,
  SLM_PERIOD_TYPES,
  STANDARD_TYPES
} from '../../models/models';
import { CommonMaterialModule } from '@nrwl/common-material';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'nrwl-y1731-performance-monitor',
  standalone: true,
  imports: [CommonModule, TestSetupModule, CommonMaterialModule, FormsModule, CommonLibModule],
  templateUrl: './y1731-performance-monitor.component.html',
  styleUrls: ['./y1731-performance-monitor.component.scss']
})
export class Y1731PerformanceMonitorComponent implements OnInit, OnDestroy {
  @ViewChild('setupForm', { static: true }) form: NgForm;
  slmPeriodTypes = SLM_PERIOD_TYPES;
  dmmPeriodTypes = DMM_PERIOD_TYPES;
  ccmPeriodTypes = CCM_PERIOD_TYPES;
  megIdFormatTypes = MEG_ID_FORMAT_TYPES;
  standardTypes = STANDARD_TYPES;
  mdNameFormatTypes = MD_NAME_FORMAT_TYPES;
  formField = {
    slmPeriod: null,
    slmDataSize: null,
    dmmPeriod: null,
    dmmDataSize: null,
    ccmPeriod: null,
    megIdFormat: null,
    megId: null,
    standard: null,
    mdNameFormat: null,
    mdName: null
  };

  constructor(
    public dialogRef: MatDialogRef<Y1731PerformanceMonitorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.formField.slmPeriod = this.data?.pm?.slmPeriod;
      this.formField.slmDataSize = this.data?.pm?.slmDataTlvSize;
      this.formField.dmmPeriod = this.data?.pm?.dmmPeriod;
      this.formField.dmmDataSize = this.data?.pm?.dmmDataTlvSize;
      this.formField.ccmPeriod = this.data?.ccm?.ccmPeriod;
      this.formField.standard = this.data?.attributes?.standard;
      if (this.data?.ccm?.ccmPeriod !== 'off') {
        this.formField.megIdFormat = 2;
        this.formField.megId = this.data?.attributes?.megId || '';
      }
      if (this.data?.attributes?.standard !== 'ITU') {
        this.formField.mdNameFormat = 2;
        this.formField.mdName = this.data?.attributes?.mdName || '';
      }
    }
  }
  ngOnInit(): void {}

  onCCMPeriodChange(): void {
    if (this.formField.megIdFormat === null) {
      this.formField.megIdFormat = this.data?.attributes?.megIdFormat || 2;
    }
  }

  onStandardChange(): void {
    if (this.formField.mdNameFormat === null) {
      this.formField.mdNameFormat = this.data?.attributes?.mdNameFormat || 2;
    }
  }

  savePerformanceMonitorData(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  ngOnDestroy(): void {}
}
